import { DATASOURCE_ACTION, BOOKING_ACTION } from "../actions";
import { deepAssign } from "../../../utils";
import HealthFunds from "../../../jsonData/HealthFunds";
import CustomFields from "../../../jsonData/CustomFields";
// import Specialties from "../../../jsonData/Specialties";
// import Practitioners from "../../../jsonData/Practitioners";
//import Locations from "../../../jsonData/Locations";
// import TimeZones from "../../../jsonData/LocationTimeZones";

const INITIAL_STATE = {
  specialtyTypes: [],
  practitioners: [],
  locations: [],
  timeSlots: [],
  timeZones: [],
  schedules: [],
  positions: {},
  healthFunds: HealthFunds.healthFunds,
  customFields: CustomFields.customFields,
  loadingTimeSlots: false
};

const updateDataSource = (state, action) => {
  const { key, values } = action.payload;

  return { ...state, [key]: values };
};

const updateTimeSlots = (state, action) => {
  const { values, concat } = action.payload;

  return {
    ...state,
    timeSlots: concat ? [...state.timeSlots, ...values] : values
  };
};

const handlePositionLoad = (state, action) => {
  const { locationId, position } = action.payload;
  return deepAssign(state, position, ["positions", locationId]);
};

export const dataSourceReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case DATASOURCE_ACTION.UPDATE_DATASOURCE:
      return updateDataSource(state, action);

    case DATASOURCE_ACTION.LOCATION_POSITION_LOAD:
      return handlePositionLoad(state, action);

    case DATASOURCE_ACTION.UPDATE_TIMESLOTS:
      return updateTimeSlots(state, action);

    case DATASOURCE_ACTION.TOGGLE_TIMESLOTS_LOADING:
      return { ...state, loadingTimeSlots: action.payload.loading };

    case BOOKING_ACTION.MAKE_NEW_BOOKING:
      return { ...state, timeSlots: [] };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/reducers/dataSourceReducer.js